module.exports = __webpack_public_path__ + "static/media/dealer_button_landscape.d06060b9.png";